export const MAGAZINE_DATA_GET = 'service/MAGAZINE_DATA_GET'
export const LOGIN_SUCCESS = 'service/LOGIN_SUCCESS'
export const RESTORE_USER = 'service/RESTORE_USER'
export const YEAR_DATA_GET = 'service/YEAR_DATA_GET'
export const MAGAZINE_FAV_DATA_GET = 'service/MAGAZINE_FAV_DATA_GET'
export const MAGAZINE_LIKE_DATA_GET = 'service/MAGAZINE_LIKE_DATA_GET'
export const BLOG_FEATURE_DATA_GET = 'service/BLOG_FEATURE_DATA_GET'
export const PURCHASED_COURSE_DATA_GET = 'service/PURCHASED_COURSE_DATA_GET'
export const LIKE_COURSE_DATA_GET = 'service/LIKE_COURSE_DATA_GET'
export const EDUCATION_TECHNICAL_CATEGORY_GET = 'service/EDUCATION_TECHNICAL_CATEGORY_GET'
export const EDUCATION_TECHNICALS_BY_CATEGORY_GET = 'service/EDUCATION_TECHNICALS_BY_CATEGORY_GET'
export const EDUCATION_COURSE_CATEGORY_GET = 'service/EDUCATION_COURSE_CATEGORY_GET'
export const EDUCATION_TEACHERS_GET = 'service/EDUCATION_TEACHERS_GET'
export const TECHNICAL_DETAIL_GET = 'service/TECHNICAL_DETAIL_GET'
export const TECHNOLOGY_DETAIL_LIST_GET = 'service/TECHNOLOGY_DETAIL_LIST_GET'
export const ONLINE_CLASS_DETAIL_GET = 'service/ONLINE_CLASS_DETAIL_GET'
export const ONLINE_CLASS_RELATED_GET = 'service/ONLINE_CLASS_RELATED_GET'
export const PRODUCT_DATA_GET = 'service/PRODUCT_DATA_GET'
export const PRODUCT_CATEGORY_GET = 'service/PRODUCT_CATEGORY_GET'
export const PRODUCT_FEATURED_GET = 'service/PRODUCT_FEATURED_GET'
export const PRODUCT_DETAIL_GET = 'service/PRODUCT_DETAIL_GET'
export const PRODUCT_BANNERS_GET = 'service/PRODUCT_BANNERS_GET'
export const EDUCATION_BANNERS_GET = 'service/EDUCATION_BANNERS_GET'
export const ADS_DATA_GET = 'service/ADS_DATA_GET'
